import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AppManualAdjustmentModalComponent } from './app-manual-adjustment-modal/app-manual-adjustment-modal.component';
import { EntityGroupDetailsService } from '../../entity-group-details.service';

@Component({
  selector: 'app-app-wallet-manual-adjustment',
  templateUrl: './app-wallet-manual-adjustment.component.html',
  styleUrls: ['./app-wallet-manual-adjustment.component.scss'],
  standalone: false,
})
export class AppWalletManualAdjustmentComponent implements OnInit {
  @Input() playerId?: number;

  constructor(
    private dialog: MatDialog,
    private entityGroupService: EntityGroupDetailsService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  openModal(): void {
    this.dialog
      .open(AppManualAdjustmentModalComponent, {
        data: { playerId: this.playerId },
        height: '90vh',
        disableClose: true,
      })
      .afterClosed()
      .subscribe(() => {
        this.entityGroupService.reloadSubject.next(this.route.snapshot.paramMap);
      });
  }
}
